const company = 'บริษัท เอ็นเดต้าธอธ จำกัด'
const address =
  '7 อาคารซัมเมอร์ พอยท์ ชั้นที่ 2 ซอยสุขุมวิท 69 <br /> แขวงพระโขนงเหนือ เขตวัฒนา กรุงเทพมหานคร 10110 ประเทศไทย'
const tel = '02-024-5560'
const email = 'sales@ndatathoth.com'

const facebook = 'https://www.facebook.com/datawowai/'
const linkedIn = 'https://www.linkedin.com/company/datawowio'
const medium = 'https://datawow.io/blogs'

export default {
  company,
  address,
  tel,
  email,
  facebook,
  linkedIn,
  medium,
}
